import CompanyOpportunitiesView from "../../components/opportunity/overview/company/CompanyOpportunitiesView";

const OpportunitiesPage = () => {
  return <CompanyOpportunitiesView />;
};

export default OpportunitiesPage;
